var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{class:_vm.options.classes,attrs:{"icon":['fas', _vm.options.currentIcon]}})
}
var staticRenderFns = []

export { render, staticRenderFns }